import ServicePrimeCloudSync from"./ServicePrimeCloudSync";export default ServicePrimeCloudSync;